import { all } from "redux-saga/effects";
import getListGame from "./getListGame";

export const gamePageSaga = function* root() {
	yield all([getListGame()]);
};
